import React, { Fragment } from 'react';

function QuienesSomos() {
    return (
        <Fragment>
            {/* --- SECCIÓN 1: BANNER PRINCIPAL --- */}
            <div className="aa-title" style={{ padding: '60px 20px', background: '#f8f9fa', textAlign: 'center' }}>
                <br />
                <a href='/'>
                    {/* --- ESPACIO PARA LA IMAGEN DE TU EMPRESA --- */}
                    <img
                        src="/imagesmain/superbieneslogo.png" // Reemplaza esto por la ruta de tu logo (ej: "/img/logo.png")
                        alt="Logo de la Empresa"
                        style={{
                            maxHeight: '80px',
                            maxWidth: '100%',
                            height: 'auto',
                            objectFit: 'contain',
                            marginBottom: '10px'
                        }}
                    />
                </a>

                <h1 style={{ color: '#1a365d', fontSize: '38px', fontWeight: 'bold', marginTop: '20px', textTransform: 'uppercase' }}>
                    Nuestra Empresa
                </h1>
                <div style={{ width: '60px', height: '4px', background: '#59abe3', margin: '15px auto 20px' }}></div>
                <p style={{ color: '#4a5568', fontSize: '18px', maxWidth: '800px', margin: '0 auto', lineHeight: '1.6' }}>
                    Conoce más sobre nuestra trayectoria, los valores que nos mueven y el compromiso que tenemos con el patrimonio de nuestros clientes.
                </p>
            </div>

            {/* --- SECCIÓN 2: QUIÉNES SOMOS / RESEÑA --- */}
            <div className="container" style={{ margin: '50px auto', maxWidth: '1000px', padding: '0 20px' }}>
                <div className="row" style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '40px' }}>

                    {/* COLUMNA DEL TEXTO */}
                    <div style={{ flex: '1.5', minWidth: '300px' }}>
                        <h2 style={{ color: '#1a365d', fontSize: '28px', fontWeight: 'bold', marginBottom: '20px' }}>
                            ¿Quiénes Somos?
                        </h2>
                        <p style={{ color: '#4a5568', lineHeight: '1.8', textAlign: 'justify', fontSize: '16px' }}>
                            ARRENDAMIENTOS SUPERBIENES SAS es una empresa familiar fundada el 1 de abril de 1990. Estamos hace 35 años en el mercado inmobiliario, prestando el servicio continuo y permanente en el sector de El Poblado pero igual en toda la ciudad. Su personal está capacitado para atender las necesidades a su distinguida clientela.
                            <br /><br />
                            La agencia es de carácter familiar y ha venido trabajando con mucho acierto en el área de propiedad raíz.
                            <br /><br />
                            Su actividad principal son arrendamientos, ventas, avalúos, hipotecas y todo lo que tiene que ver en este sector inmobiliario.
                            <br /><br />
                            La empresa fue fundada por el señor LEONARDO SANCHEZ SANCHEZ, quien viene trabajando en esta actividad desde hace 40 años siendo condecorado por la entidad FENALCO por los servicios prestados en esta actividad de servicios.
                        </p>
                    </div>

                    {/* COLUMNA DEL LOGO DE FENALCO */}
                    <div className="col-lg-5">
                        <div
                            className="card border-0 shadow-sm p-4 text-center bg-white rounded-card feature-card d-flex flex-column align-items-center justify-content-center"
                            style={{ borderRadius: '24px' }}
                        >
                            <img
                                src="/imagesmain/Logo-Fenalco-Antioquia.png"
                                alt="Afiliado a Fenalco Antioquia"
                                className="img-fluid mb-3 custom-img"
                                style={{ maxWidth: '190px', filter: 'drop-shadow(0px 4px 6px rgba(0,0,0,0.06))' }}
                            />
                            <span style={{
                                fontSize: '13px',
                                color: '#718096',
                                fontWeight: '600',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px'
                            }}>
                                Gremio de Comercio
                            </span>
                        </div>
                    </div>

                </div>
            </div>

            {/* --- SECCIÓN 3: MISIÓN Y VISIÓN --- */}
            <div className="bg-light py-5 my-5 rounded-5 mx-2">
                <div className="container py-3">
                    <div className="row g-4 justify-content-center">

                        {/* Tarjeta de Misión */}
                        <div className="col-12 col-md-6 col-lg-5">
                            <div
                                className="card border-0 shadow-sm p-4 p-md-5 bg-white h-100 rounded-card feature-card"
                                style={{ borderRadius: '24px' }}
                            >
                                <div className="d-inline-flex align-items-center justify-content-center bg-primary-subtle rounded-circle p-3 mb-4 icon-box" style={{ width: '70px', height: '70px' }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="#0d6efd" className="bi bi-rocket-takeoff-fill" viewBox="0 0 16 16">
                                        <path d="M12.17 9.47a1.5 1.5 0 0 0 0-2.94l-2.13-.71a1.5 1.5 0 0 0-1.92-1.92l-.71-2.13a1.5 1.5 0 0 0-2.94 0l-.71 2.13a1.5 1.5 0 0 0-1.92 1.92l-2.13.71a1.5 1.5 0 0 0 0 2.94l2.13.71a1.5 1.5 0 0 0 1.92 1.92l.71 2.13a1.5 1.5 0 0 0 2.94 0l.71-2.13a1.5 1.5 0 0 0 1.92-1.92zM10.5 7a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3" />
                                    </svg>
                                </div>
                                <h3 className="fw-bold text-dark h4 mb-3">Misión</h3>
                                <p className="text-muted leading-relaxed text-justify mb-0">
                                    Vender, arrendar, hipotecar y administrar profesionalmente todos los bienes inmuebles que nuestros clientes nos consignen; con mucha responsabilidad social empresarial, trabajo en equipo, liderazgo en nuestro campo de acción, con proyección a la comunidad.
                                </p>
                            </div>
                        </div>

                        {/* Tarjeta de Visión */}
                        <div className="col-12 col-md-6 col-lg-5">
                            <div
                                className="card border-0 shadow-sm p-4 p-md-5 bg-white h-100 rounded-card feature-card"
                                style={{ borderRadius: '24px' }}
                            >
                                <div className="d-inline-flex align-items-center justify-content-center bg-primary-subtle rounded-circle p-3 mb-4 icon-box" style={{ width: '70px', height: '70px' }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="#0d6efd" className="bi bi-eye-fill" viewBox="0 0 16 16">
                                        <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
                                        <path d="M0 8s3-5.5 8-5.5S16 8 16 8s3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
                                    </svg>
                                </div>
                                <h3 className="fw-bold text-dark h4 mb-3">Visión</h3>
                                <p className="text-muted leading-relaxed text-justify mb-0">
                                    Estamos proyectados en ser una de las empresas líderes y reconocidas en el mercado de propiedad raíz en el Valle de Aburrá, por su responsabilidad y eficacia en todos los servicios que prestamos a la sociedad. Seremos la empresa preferida por la calidad y confiabilidad en la prestación de todos nuestros servicios.
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            {/* --- SECCIÓN 4: VALORES CORPORATIVOS --- */}
            <div className="container my-5 py-3">
                <div className="text-center mb-5">
                    <h2 className="fw-bold text-dark mb-2">Nuestros Valores</h2>
                    <div className="bg-primary mx-auto mb-3 rounded-pill" style={{ width: '50px', height: '4px' }}></div>
                    <p style={{ color: '#718096' }}>Los pilares que guían cada una de nuestras acciones y negocios.</p>
                </div>

                <div className="row g-4 justify-content-center">
                    {/* Valor 1 */}
                    <div className="col-12 col-sm-6 col-md-4">
                        <div
                            className="card border-0 shadow-sm p-4 text-center bg-white h-100 rounded-card feature-card"
                            style={{ borderRadius: '20px' }}
                        >
                            <div className="d-inline-flex align-items-center justify-content-center bg-light rounded-circle p-3 mb-3 mx-auto icon-box" style={{ width: '64px', height: '64px' }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#0d6efd" className="bi bi-shield-check" viewBox="0 0 16 16">
                                    <path d="M5.338 1.59a61 61 0 0 0-2.837.856.481.481 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.7 10.7 0 0 0 2.287 2.233c.346.244.652.244 1 0a10.7 10.7 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.656-.242-1.542-.54-2.837-.856.48.48 0 0 0-.24 0zM8 0c.069 0 .138.003.207.01a65 65 0 0 1 3.33.991c.71.255 1.192.964 1.053 1.74-.508 2.857-1.185 5.517-2.43 7.558a11.7 11.7 0 0 1-2.944 3.313c-.48.34-1.133.34-1.613 0A11.7 11.7 0 0 1 2.784 10.3c-1.245-2.041-1.922-4.7-2.43-7.558C.216 1.965.698 1.256 1.408 1a65 65 0 0 1 3.33-.991C4.803.003 4.872 0 4.94 0z" />
                                    <path d="M10.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0" />
                                </svg>
                            </div>
                            <h4 className="fw-bold text-dark h5 m-0">Confianza</h4>
                        </div>
                    </div>

                    {/* Valor 2 */}
                    <div className="col-12 col-sm-6 col-md-4">
                        <div
                            className="card border-0 shadow-sm p-4 text-center bg-white h-100 rounded-card feature-card"
                            style={{ borderRadius: '20px' }}
                        >
                            <div className="d-inline-flex align-items-center justify-content-center bg-light rounded-circle p-3 mb-3 mx-auto icon-box" style={{ width: '64px', height: '64px' }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#0d6efd" className="bi bi-building-check" viewBox="0 0 16 16">
                                    <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.708l.547.548 1.17-1.951a.5.5 0 1 1 .858.514M2 1a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6.5a.5.5 0 0 1-1 0V1H3v14h3a.5.5 0 0 1 0 1H3a1 1 0 0 1-1-1z" />
                                </svg>
                            </div>
                            <h4 className="fw-bold text-dark h5 m-0">Transparencia</h4>
                        </div>
                    </div>

                    {/* Valor 3 */}
                    <div className="col-12 col-sm-6 col-md-4">
                        <div
                            className="card border-0 shadow-sm p-4 text-center bg-white h-100 rounded-card feature-card"
                            style={{ borderRadius: '20px' }}
                        >
                            <div className="d-inline-flex align-items-center justify-content-center bg-light rounded-circle p-3 mb-3 mx-auto icon-box" style={{ width: '64px', height: '64px' }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#0d6efd" className="bi bi-people-fill" viewBox="0 0 16 16">
                                    <path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5.784 6A2.24 2.24 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.3 6.3 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1zM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
                                </svg>
                            </div>
                            <h4 className="fw-bold text-dark h5 m-0">Compromiso</h4>
                        </div>
                    </div>
                </div>
            </div>

            {/* --- SECCIÓN 5: NUESTRA SEDE ÚNICA --- */}
            <div className="bg-light py-5 my-5 rounded-5 mx-2">
                <div className="container py-3 text-center">
                    <h2 className="fw-bold text-dark mb-2">Nuestra Sede</h2>
                    <div className="bg-primary mx-auto mb-4 rounded-pill" style={{ width: '50px', height: '4px' }}></div>

                    <div className="d-flex justify-content-center">
                        <a
                            href="https://www.google.com/maps?ll=6.21168,-75.569712&z=15&t=m&hl=es&gl=CO&mapclient=embed&cid=17983933689347801370"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="card border-0 shadow-lg overflow-hidden text-decoration-none text-white sede-card position-relative"
                            style={{ borderRadius: '24px', maxWidth: '420px', width: '100%', height: '320px' }}
                        >
                            <img
                                src="/imagesmain/Location.png"
                                alt="Sede Principal El Poblado"
                                className="w-100 h-100 object-fit-cover sede-img"
                            />
                            {/* Capa de degradado sobre la foto para mejorar legibilidad */}
                            <div
                                className="position-absolute top-0 start-0 w-100 h-100"
                                style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.2) 60%, rgba(0,0,0,0) 100%)' }}
                            ></div>

                            {/* Texto flotante sobre la imagen */}
                            <div className="position-absolute bottom-0 start-0 w-100 p-4 text-center">
                                <div className="bg-primary mx-auto mb-2 rounded-pill" style={{ width: '40px', height: '3px' }}></div>
                                <h3 className="h4 fw-bold text-white mb-1">Sede Principal</h3>
                                <p className="m-0 text-white-50 small">Sector El Poblado</p>
                                <p className="m-0 text-white-50 small">Medellín, Colombia</p>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

// Estilos de objetos reutilizables:
const cardStyle = {
    position: 'relative',
    display: 'block',
    borderRadius: '10px', // Cambiado a 10px completo para que se vea más pulido como tarjeta única
    overflow: 'hidden',
    height: '288px', // Equivalente a h-72
    textDecoration: 'none',
    boxShadow: '0 4px 10px rgba(0,0,0,0.1)'
};

const imageStyle = {
    position: 'absolute',
    height: '100%',
    width: '100%',
    inset: '0px',
    objectFit: 'cover',
    color: 'transparent'
};

const overlayStyle = {
    position: 'absolute',
    inset: '0px',
    background: 'rgba(0, 0, 0, 0.45)' // Capa oscura para leer bien los textos blancos
};

const contentContainerStyle = {
    position: 'absolute',
    inset: '0px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    color: '#fff',
    padding: '0 16px'
};

const miniDividerStyle = {
    width: '76px',
    height: '5px',
    background: '#59abe3',
    marginBottom: '12px'
};

const titleStyle = {
    fontWeight: 'bold',
    fontSize: '22px',
    margin: '0 0 4px 0'
};

const textStyle = {
    fontSize: '15px',
    lineHeight: '1.25',
    margin: '4px 0 0 0'
};

export default QuienesSomos;